import { ObjectModelTriggerRunsForType } from "~/enums/objectModelTriggerRunsForType";
import assertNever from "../../../global/assetNever";
import { ObjectModelTriggerType } from "../../enums/objectModelTriggerType";
import { EnumHelper } from "../../helpers/enumHelper";
import ObjectModelTrigger from "./objectModelTrigger";
import { ObjectModelTriggerCapability } from "./objectModelTriggerCapability";

export default class ObjectModelTriggerCapabilityManager {
  static debug: boolean = false;

  static LABELABLE_TRIGGERS = [
    ObjectModelTriggerType.AutoGenerateForm,
    ObjectModelTriggerType.AutomaticNotification,
    ObjectModelTriggerType.UpdatePropertyValues,
    ObjectModelTriggerType.RunMapping,
    ObjectModelTriggerType.LogEventInHistory,
    ObjectModelTriggerType.RemoveRelationship,
    ObjectModelTriggerType.EstablishRelationship,
    ObjectModelTriggerType.RunProcess,
  ];

  static FORM_LINKABLE_TRIGGERS = [
    ObjectModelTriggerType.AutoGenerateForm,
  ];

  static RELATED_OBJECT_PROPERTY_UPDATABLE=[
    ObjectModelTriggerType.UpdatePropertyValues,
  ]

  static RUNNABLE_FOR_TRIGGERS = [
    ObjectModelTriggerType.RunProcess,
  ]

  static PROPERTY_UPDATEABLE_TRIGGERS = [
    ObjectModelTriggerType.UpdatePropertyValues
  ]

  static RUN_MAPPABLE_TRIGGERS=[
    ObjectModelTriggerType.RunMapping
  ]

  static RUN_PROCESSABLE_TRIGGERS = [
    ObjectModelTriggerType.RunProcess
  ]

  static CONDITIONABLE_TRIGGERS =[
    ObjectModelTriggerType.AutoGenerateForm,
    ObjectModelTriggerType.AutomaticNotification,
    ObjectModelTriggerType.UpdatePropertyValues,
    ObjectModelTriggerType.RunMapping,
    ObjectModelTriggerType.LogEventInHistory,
    ObjectModelTriggerType.RemoveRelationship,
    ObjectModelTriggerType.EstablishRelationship,
    ObjectModelTriggerType.RunProcess,
  ]

  static REMOVE_RELATIONSHIPABLE=[
    ObjectModelTriggerType.RemoveRelationship
  ]

  static ESTABLISH_RELATIONSHIPABLE=[
    ObjectModelTriggerType.EstablishRelationship
  ]

  static can(type: ObjectModelTriggerType, duty: ObjectModelTriggerCapability): boolean {
    let can = false;
    switch (duty) {
      case ObjectModelTriggerCapability.labelable:
        can = ObjectModelTriggerCapabilityManager.LABELABLE_TRIGGERS.includes(type);
        break;
      case ObjectModelTriggerCapability.formLinkable:
        can = ObjectModelTriggerCapabilityManager.FORM_LINKABLE_TRIGGERS.includes(type);
        break;
      case ObjectModelTriggerCapability.triggerConditionable:
        can = ObjectModelTriggerCapabilityManager.CONDITIONABLE_TRIGGERS.includes(type);
        break;
      case ObjectModelTriggerCapability.propertyUpdateable:
        can = ObjectModelTriggerCapabilityManager.PROPERTY_UPDATEABLE_TRIGGERS.includes(type);
        break;
      case ObjectModelTriggerCapability.runMappable:
        can = ObjectModelTriggerCapabilityManager.RUN_MAPPABLE_TRIGGERS.includes(type);
        break;
      case ObjectModelTriggerCapability.runProcessable:
        can = ObjectModelTriggerCapabilityManager.RUN_PROCESSABLE_TRIGGERS.includes(type);
        break;
      case ObjectModelTriggerCapability.relatedObjectPropertyUpdatable:
        can = ObjectModelTriggerCapabilityManager.RELATED_OBJECT_PROPERTY_UPDATABLE.includes(type);
        break;
      case ObjectModelTriggerCapability.removeRelationshipable:
        can = ObjectModelTriggerCapabilityManager.REMOVE_RELATIONSHIPABLE.includes(type);
        break;
      case ObjectModelTriggerCapability.establishRelationshipable:
        can = ObjectModelTriggerCapabilityManager.ESTABLISH_RELATIONSHIPABLE.includes(type);
        break;
      case ObjectModelTriggerCapability.triggerRunnableFor:
        can = ObjectModelTriggerCapabilityManager.RUNNABLE_FOR_TRIGGERS.includes(type);
        break;
      default:
        assertNever(duty);
        can = false;
        break;
    }
    ObjectModelTriggerCapabilityManager.log(`Tupe ${ObjectModelTriggerType[type]} ${can ? 'can' : 'can\'t'} ${ObjectModelTriggerCapability[duty]}`);
    return can;
  }

  static addDefaultProperties(trigger: ObjectModelTrigger) {
    EnumHelper.toArray( ObjectModelTriggerCapability).forEach((c: ObjectModelTriggerCapability) => {
      switch (c) {
        case ObjectModelTriggerCapability.labelable:
          const defaultLabel ="Untitled Event";
          trigger.defineProperty('label_title', defaultLabel);
          break;
        case ObjectModelTriggerCapability.formLinkable:
          trigger.defineProperty('linked_form_id', null);
          trigger.defineProperty('restrict_form_viewers', false);
          break;
        case ObjectModelTriggerCapability.triggerConditionable:
          break;
        case ObjectModelTriggerCapability.propertyUpdateable:
          break;
        case ObjectModelTriggerCapability.runMappable:
          trigger.defineProperty('mapping_id', null);
          break;
        case ObjectModelTriggerCapability.runProcessable:
          trigger.defineProperty('process_flow_id', null);
          break;
        case ObjectModelTriggerCapability.triggerRunnableFor:
          trigger.defineProperty('trigger_runs_for_type', ObjectModelTriggerRunsForType.Individual);
          break;
        case ObjectModelTriggerCapability.relatedObjectPropertyUpdatable:
          trigger.defineProperty('linked_relationship_title', null);
          break;
        case ObjectModelTriggerCapability.establishRelationshipable:
          trigger.defineProperty('foreign_key', "")
          trigger.defineProperty('linked_relationship_client_id', "");
          break;
        case ObjectModelTriggerCapability.removeRelationshipable:
          trigger.defineProperty('relationship_id', "");
          break;
        default:
          assertNever(c);
          break;
      }
    });
  }

  private static log(message: string) {
    if (this.debug) {
      console.log(`DEBUG: ObjectModelTriggerCan: ${message}`);
    }
  }
}